export const SEARCH = 'SEARCH';
export const AGGREGATION = 'AGGREGATION';
export const TIME_SERIES = 'TIME_SERIES';
export const PIPELINE = 'PIPELINE';
export const FUNNEL = 'FUNNEL';
export const TEMPLATE = 'TEMPLATE';
export const REPORT_GROUP = 'REPORT_GROUP';